import type { FaireProductEntity } from "../../entity_types/product";

export const p_prh33kaxss: FaireProductEntity = {
  token: "p_prh33kaxss",
  type: "product",
  name: "Minimalist Large Capacity Draped Shoulder Bag",
  brandToken: "b_2ig5ozgc",
  brandName: "Vanilla Monkey",
  imageUrl:
    "https://cdn.faire.com/fastly/ff8707fa3ddfe342eb1f1697b0b74a2c4d772c669cd4b6ef7f7c07cbeb0902be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4a45b788d0edb6a475538e9ae7ebbeebe3cdbb848c21999dd30d3c3d1731f475.jpeg",
    "https://cdn.faire.com/fastly/ca354cc26d87c43d37fde8b948cbc8cd9cc53ddbb3cb6c023eac149d03ed7d6d.jpeg",
    "https://cdn.faire.com/fastly/c9f6429b45b86c80b817d7b7cd91ec3fcaf81f7e1840ee80391d9c337f62d406.jpeg",
    "https://cdn.faire.com/fastly/27b751872c32b449beb02dee368c9073aae73c2bd835754ec45ba158110eb7d4.jpeg",
    "https://cdn.faire.com/fastly/cf06f1ae1c13528fac52e4cfc2405eb88e2e2d288319031aef70c75850c65dc1.jpeg",
    "https://cdn.faire.com/fastly/71517350e942a87bd499095c3c2f34efa9c2ab5a6dbc63ad81d6172c34e48b76.jpeg",
    "https://cdn.faire.com/fastly/0c08a82811101a5fb2d3286883c4aa25f1ec42a1a3f7f348d0dc713db1029938.jpeg",
  ],
  priceDollars: 9,
  description:
    'MINIMALIST LARGE CAPACITY DRAPED SHOULDER BAG\r\n\r\n-TRENDY STYLE\r\n-LARGE CAPACITY\r\n-RETRO PATCH DESIGN\r\n-SIMPLE &amp; MINIMALIST\r\n-DURABLE &amp; LIGHTWEIGHT\r\n-WEATHER RESISTANT\r\n-CARRYALL ESSENTIALS\r\n-PERFECT FOR TRAVELING OR EVERYDAY USE\r\n-LENGTH: 19.7", HEIGHT: 15.5", WIDTH: 0.5"\r\n\r\n*COLOR MAY VARY SLIGHTLY DUE TO MONITOR RESOLUTION*\r\n\r\nMaterial Composition\r\nNYLON',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:46.436Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
